/**
 * Boli Live - Toaster Component (placeholder)
 */

export function Toaster() {
  return null; // Placeholder - implement with @radix-ui/react-toast
}
